(ns ycweb.app.website.voucher.balance
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(defmethod grid/action :gift-vouchers/check-balance [app-atom {:keys [captcha-token]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher-atom (rum/cursor process-atom :voucher)
        code (cmn/curact voucher-atom :code)]
    (comms/ajax-get :gift-vouchers/check-balance
      {:code code :captcha-token captcha-token})))

(defmethod comms/receive :gift-vouchers/check-balance [app-atom {:keys [feedback] :as e}]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher-atom (rum/cursor process-atom :voucher)]
    (toaster/close-toast app-atom)
    (swap! voucher-atom assoc :feedback feedback)
    (when (= (:voucher/status feedback) :success)
      (urlstate/redirect app-atom "gift-vouchers" "balance-show"))))

(rum/defc voucher-feedback < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher-atom (rum/cursor process-atom :voucher)
        {:voucher/keys [status title expires-on] :as feedback}
        (cmn/curact voucher-atom :feedback)]
    (when
      (and
        (:voucher/type feedback)
        (not= status :success))
      [:div.section.section--medium
       (cond
         (= (:voucher/type feedback) :invalid-code)
         (feedback/feedback :error "Voucher code not valid"
           ["Sorry, we couldn't find a Gift Card or Gift Voucher with that code.
             Please check the code or contact "
            [:a {:href "/help.htm"} "Customer Service"] " for help."])

         (= (:voucher/type feedback) :voucher-expired)
         (feedback/feedback :error "Voucher has expired"
           ["Sorry, that voucher expired on "
            (ud/format-date expires-on "d MMM YYYY") ". "
            "Please check the code or contact "
            [:a {:href "/help.htm"} "Customer Service"] " for help."])

         (= (:voucher/type feedback) :redeemed)
         (feedback/feedback :warning "Voucher has been redeemed"
           ["Sorry, that voucher has been fully used already.
             Please check the code or contact "
            [:a {:href "/help.htm"} "Customer Service"] " for help."])

         (= (:voucher/type feedback) :mystery-voucher)
         (feedback/feedback :error "Mystery Voucher"
           ["Sorry, this is a Mystery Voucher and cannot be redeemed unless
             the code is revealed and activated in store."])

         :else
         (feedback/feedback :error title))])))

(rum/defc voucher-balance [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [captcha-site-key]} (cmn/curact app-atom :config)
        voucher-atom (rum/cursor process-atom :voucher)]
    [:<>
     [:div
      {:class (u/bem :yc-page-content [:standard])}
      [:div
       {:class (u/bem :yc-section [:medium-underline])}
       [:div.yc-intro-text
        (headings/heading "Gift Cards and Gift Vouchers"
          {:type :h1
           :pretext "Learn more about"
           :size :large
           :center true})
        [:div.u-block-center.u-max-width-540
         (web-common/lazy-image app-atom
           "pages/gift-vouchers/yuppiechef-gift-card-voucher-balance"
           {:class ["yc-simple-image  yc-simple-image--full  yc-simple-image--s-margin"]}
           {:w 540
            :q "auto"
            :alt "Yuppiechef Gift Cards and Gift Vouchers"})]
        [:p.yc-paragraph
         "Congrats on your Gift Card or Voucher. Lucky! You're welcome to use it either online when checking out on Yuppiechef.com or shopping in store. To use online, simply enter the voucher code at Checkout. To use in store, simply hand your card or code to the sales assistant when paying for your goods. "
         [:a
          {:href "/help.htm?action=article&id=52"
           :class (u/bem :text-link [:muted])}
          "Find out more."]]
        [:div.u-block-center.u-max-width-480
         [:div.flex-grid-group
          [:div
           {:class (u/bem :flex-grid-block [:m-1-2])}
           [:div.flex-grid-content
            (buttons/button-web "Terms & Conditions"
              {:href "/help.htm?action=article&id=119"
               :style :secondary
               :full true})]]]]]
       [:p
        {:class (u/bem :yc-paragraph [:small] :u-text-center)}
        [:b
         [:a
          {:href "#"
           :on-click #(scroll/scroll-to-id % "intro-block")
           :class (u/bem :text-link [:muted])}
          "New to Yuppiechef?"]]
        " "
        [:span.u-pipe
         "|"]
        " "
        [:a
         (merge
           (urlstate/href-props app-atom "gift-vouchers" "")
           {:class (u/bem :text-link [:muted])})
         "Want to buy a Gift Voucher?"]]]
      [:div
       {:id "js-check-voucher-balance"
        :class (u/bem :yc-section [:medium-underline])}
       [:div.u-block-center.u-max-width-480
        (headings/heading "Check Your Balance"
          {:type :h2
           :size :medium
           :center true})
        (voucher-feedback app-atom)
        [:form.form
         [:div.form-field.u-max-width-480.u-block-center
          (forms/input "Enter your voucher code:" "e.g. 123-456-789"
            (rum/cursor voucher-atom :code)
            {:type :text
             :name :code
             :value :code
             :auto-focus true
             :required true
             :hint (list [:b "Gift Card?"] " Your voucher code is found below the QR code.")})]
         [:div.form-control
          (buttons/button-web "Check Balance"
            {:type :button
             :style :primary
             :on-click
             #(do
                (toaster/open-toast app-atom :processing "Loading" {})
                (appcommon/recaptcha app-atom captcha-site-key :gift-vouchers/check-balance {}))})]]]]
      [:aside
       {:class (u/bem :yc-section [:large])}
       [:div.u-block-center.u-max-width-720
        {:id "intro-block"}
        (web-common/lazy-image app-atom
          "pages/content-blocks/yuppiechef-product-range"
          {:class ["yc-simple-image  yc-simple-image--full  yc-simple-image--shadow  yc-simple-image--m-margin"]}
          {:w 720
           :q "auto"
           :alt "Yuppiechef Kitchen and Homeware Range"})
        (headings/heading "Learn More About Yuppiechef"
          {:type :h3
           :size :small
           :center true})
        [:p.yc-paragraph.u-text-center
         [:b "Yuppiechef"]
         " is South Africa's premier kitchen and homeware store, stocking 700 of the world's leading brands. From knives, cookware and appliances, to soft furnishings, craft spirits and the finest ingredients; we've sourced, tried and tested the best quality products we can find."]
        [:div.u-block-center.u-max-width-480
         [:div.flex-grid-group
          [:div
           {:class (u/bem :flex-grid-block [:m-1-2])}
           [:div.flex-grid-content
            (buttons/button-web "Start Shopping"
              {:href "/index.htm?ref=voucherbalancepage"
               :style :secondary
               :size :default
               :full true})]]
          [:div
           {:class (u/bem :flex-grid-block [:m-1-2])}
           [:div.flex-grid-content
            (buttons/button-web "Buy a Gift Voucher"
              (merge
                (urlstate/href-props app-atom "gift-vouchers" "")
                {:style :secondary
                 :size :default
                 :full true}))]]]]]]]]))

(defmethod t/transition-after-open :web.gift-vouchers/balance [app-atom _ _]
  (let [params (cmn/screen-params app-atom)]
    (swap! app-atom dissoc :voucher)
    (when (:scroll params)
      (scroll/scroll-to-id nil "js-check-voucher-balance"))))

(defmethod flow/render-screen :web.gift-vouchers/balance [app-atom _]
  (website/screen-wrapper app-atom
    (voucher-balance app-atom) {}))
